///include /assets/js/app/p/user.js
///include /assets/js/app/p/user-contact-info.js
///include /assets/js/app/p/support-articles/support-articles.js
///include /assets/js/app/20i/hostshop/renewal-run-config-read-only.js

///include /assets/js/shared/service-counts.js



///include /assets/js/plugins/network-property-set.js
///include /assets/js/app/p/service-limit-support.js

class SNInvoiceLine {
    constructor(lineData){
        this.id                     = lineData.id;
        this.label                  = lineData.label;
        this.linesRefundingThisLine = lineData.linesRefundingThisLine;
        this.periodMonths           = lineData.periodMonths;
        this.priceExcludingTax      = +lineData.priceExcludingTax;
        this.priceIncludingTax      = +lineData.priceIncludingTax;
        this.expectedCharges        = lineData.expectedCharges;
        this.basketItemName         = lineData.basketItemName;
        this.productCode            = lineData.productCode;
        this.provisioned            = lineData.provisioned;
    }
}

class SNInvoice extends NetworkPropertySet {
    constructor(data, invoicePrefix = `/n/payment/invoice/v2`, paymentItems = null) {
        super();
        this.cancelled                = !!data.cancelled;
        this.createdAt                = data.createdAt || data.orderTimestamp;
        this.currency                 = data.currency;
        this.customerContact          = data.customerContact ? (new InvoiceCustomerContact(data.customerContact)) : null;
        this.orderTimestamp           = data.orderTimestamp;
        this.supplierContact          = data.supplierContact;
        this.derivedTotalExcludingTax = +data.derivedTotalExcludingTax;
        this.derivedTotalIncludingTax = +data.derivedTotalIncludingTax;
        this.refundingInvoice         = [];
        this.isRefundFor              = data.isRefundFor;
        this.taxRatePercent           = +data.taxRatePercent;
        this.id                       = data.externalId;
        this.status                   = data.status;
        this.state                    = data.state;
        this.owningUser               = data.owningUser || data.owner;
        this.invoicePrefix            = invoicePrefix;

        // network props
        this.transactions             = null;
        this.paymentItems             = paymentItems;
        this.outstanding              = null;
    }

    async addTransaction( paymentItems ){
        try {
            var r = await $.ajax({
                url: `${this.invoicePrefix}/${this.id}`,
                contentType: 'application/json',
                method: 'post',
                data: JSON.stringify({
                    id: null,
                    jsonrpc: "2.0",
                    method: "addTransaction",
                    params: [paymentItems],
                }),
            });
            return {id: r.result};
        } catch (e) {
            if( e.responseJSON && e.responseJSON.error ){
                switch(e.responseJSON.error.message){
                    case 'pending abuse check':
                        ShowNotification.fail( translation.get("add_transaction_fail_pending_abuse") );
                        break;
                    default:
                }
            }
        }
    }

    get networkPropertyHandlers() {
        return {
            transactions: () => $.ajax(`${this.invoicePrefix}/${this.id}/transaction`),
            paymentItems: () => $.ajax(`${this.invoicePrefix}/${this.id}/paymentItems`),
            outstanding:  () => $.ajax(`${this.invoicePrefix}/${this.id}/outstandingBalance`),
        }
    }

    get associatedPayments() {
        if( this.paymentItems ){
            var paymentItemList = [];
            for(const tuple in this.paymentItems.displayByTuple){
                var parts = tuple.split(":");
                paymentItemList.push({
                    label: Catalogue.realPaymentTypeLabel(parts[0])
                });
            }
            return paymentItemList;
        } else {
            return [];
        }
    }

    /**
     * Check for a card transaction so the UI does not show card column
     * when no cards numbers would be shown.
     */
    get hasCardTransaction() {
        return !!this.transactionList.find( t => t.type == 'card' );
    }

    get refundStatus() {
        if( this.refundingInvoice.length < 1 ){
            return null; // Not refunded
        } else if ( this.refundedTotal == this.derivedTotalIncludingTax ) {
            return "full";
        } else if ( this.refundedTotal > 0 ){
            return "part";
        }
    }

    get refundedTotal() {
        if( this.refundingInvoice.length < 1 ){
            return 0;
        } else {
            var total = 0;
            for(const i of this.refundingInvoice){
                total+=Math.abs(i.derivedTotalIncludingTax);
            }
            return total;
        }
    }

    setRefundingInvoice(invoice) {
        this.refundingInvoice.push(invoice);
    }

    get transactionList() {
        if( this.transactions && this.paymentItems ){
            var list = [];
            for(const transaction of this.transactions){
                var type = transaction.paymentTuple.split(":")[0];
                list.push({
                    id: transaction.id,
                    type: type,
                    state: transaction.state,
                    amount: transaction.amount,
                    pan: (this.paymentItems.displayByTuple[transaction.paymentTuple] ? this.paymentItems.displayByTuple[transaction.paymentTuple].pan : null),
                    upstreamHref: transaction.externalUpstreamHref
                });
            }
            return list;
        } else {
            return [];
        }
    }

    /**
     * Get the invoice external ID
     * @type {string}
     */
    get externalId() {
        return this.id;
    }

    get labels() {
        return this.lines.map( (line) => {
            return line.label;
        } );
    }

    get orderedAt() {
        return this.createdAt;
    }

    /**
     * @type {?number}
     */
    get paymentOutstanding() {
        if( this.outstanding ){
            return this.outstanding.billingAmount;
        } else {
            return null;
        }
    }

    /**
     * @type {bool}
     */
    get unpaid() {
        return this.status == 'unpaid';
    }

}

class SNInvoiceCollection {
    /**
     *
     * @param {Invoice[]} items
     */
    constructor(items) {
        this.items = items.sort(
            (a, b) => {
                if( b && b.basicTaxPoint && a && a.basicTaxPoint ){
                    return b.basicTaxPoint.localeCompare(a.basicTaxPoint);
                } else {
                    return 0;
                }
            }
        )
        /** @type {string} */
        this.query = ""
        this.invoices = {};
    }
    get filtered() {
        if(this.query) {
            const r = new RegExp(this.query, "i")
            return this.items && this.items.filter(
                invoice =>
                    ("" + invoice.id).match(r) ||
                    invoice.basicTaxPoint.match(r) ||
                    invoice.labels.find(
                        l => l && l.match(r)
                    ) ||
                    ("" + invoice.total_excluding_vat).match(r) ||
                    ("" + invoice.total_including_vat).match(r) ||
                    ("" + invoice.eventId).match(r)
            )
        } else {
            return this.items
        }
    }
    get length() {
        return this.items.length
    }

    static async fetchAllByStatus(sta) {
        if( !this.invoices ){
            this.invoices = {};
        }
        if(this.invoices[sta]) return this.invoices[sta]
        if( !this.invoices[sta] ){
            this.invoices[sta] = [];
        }

        /**
         * @type {GET.Stack.Payment.$ns.invoice.output}
         */
        const invoices_in_extended = await $.ajax({
            url: `/n/payment/invoice/v2`,
            data: {
                selector: {
                    "status": sta
                }
            },
        })
        for (const i of invoices_in_extended) {
            this.invoices[sta].push(new SNInvoice(i))

            if (i.isRefundFor) {
                const inv = this.invoices[sta].find(io => io.id == i.isRefundFor);
                if (inv) {
                    inv.setRefundingInvoice(new SNInvoice(i));
                }
            }

        }
        return this.invoices[sta].sort(
            (a, b) => +a.id - +b.id
        )
    }

    static async fetchAbuse() {
        return (await SNInvoiceCollection.fetchAllByStatus('abuse-check'));
    }

    static async fetchNotPaid() {
        return (await SNInvoiceCollection.fetchAllByStatus('unpaid'));
    }
}

// Sorry
// https://i.ytimg.com/vi/P3kypyfZwSc/maxresdefault.jpg
class ServiceLimits2 extends NetworkPropertySet {
  /**
   *
   * @param {string} type
   * @param {string} ref
   */
  constructor(type, ref) {
      super()
      this.type = type
      this.ref = ref
      /** @type {?{result: storedLimits, deactivation: ?string}} */
      this.sessionlimitInfo = null
      if(sessionStorage[this.cacheUID]) {
          this.sessionlimitInfo = {
              result: JSON.parse(sessionStorage[this.cacheUID]),
              deactivation: null
          }
          this.reload(["sessionlimitInfo"])
      }
      this.disabled = [];
  }
  get cacheUID() {
      return `sessionLimits.${this.type}:${this.ref}`
  }
  get limits() {
      if(!this.sessionlimitInfo) return null
      let limits = ServiceLimitSupport.realLimits(this.sessionlimitInfo.result)
      for(const l of this.disabled){
          limits[l] = false;
      }
      sessionStorage[this.cacheUID] =
          JSON.stringify(this.sessionlimitInfo.result)
      return limits
  }
  get networkPropertyHandlers() {
      return {
          sessionlimitInfo: () => $.ajax(
              `/a/${this.type}/${this.ref}/sessionlimits`
          ).then(
              /**
               * @param {storedLimits} result
               * @param {string} status_text
               * @param {JQuery.jqXHR} jqXHR
               */
              (result, status_text, jqXHR) => $.Deferred().resolve({
                  result: result,
                  deactivation: jqXHR.getResponseHeader("X-Deactivation")
              })
          ),
      }
  }
  get unrenewed() {
      return(
          this.sessionlimitInfo &&
          this.sessionlimitInfo.deactivation == "renewal"
      )
  }

  disableLimit(limit){
      // is set and is true
      if(typeof this.limits[limit] !== 'undefined' && this.limits[limit]){
          this.disabled.push(limit);
          this.reload(["sessionlimitInfo"])
      }
  }
}

// Sorry again
class ServiceCounts2 extends NetworkPropertySet {
  /**
   * @param {User} user
   */
  constructor(user) {
      super()
      /** @type {?number} */
      this.domain = null
      /** @type {?number} */
      this.mssql = null
      /** @type {?number} */
      this.package = null
      /** @type {?number} */
      this.package_allowance = null
      /** @type {?number} */
      this.reseller = null
      /** @type {?number} */
      this.vps = null
      this.user = user
      /** @type {?number} */
      this.wordpress_allowance = null
  }
  get networkPropertyHandlers() {
      return {
          domain: () =>
              this.conditionalCollectionLength(`/a/domain`, "manageDomain"),
          mssql: () =>
              this.conditionalCollectionLength(`/a/mssql`, "manageWeb"),
          package: () =>
              this.conditionalCollectionLength(`/a/package`, "manageWeb"),
          package_allowance: () =>
              this.conditionalCollectionLength(`/a/package_allowance`, "manageWeb"),
          reseller: () => this.user.preloadSingle("hasReseller").then(
              hr => +hr
          ),
          vps: () => this.conditionalCollectionLength(`/a/vps`, "manageVPS"),
          managed_vps: () => this.conditionalCollectionLength(`/a/managed_vps`, "manageVPS"),
          wordpress_allowance: () =>
              this.conditionalCollectionLength(`/a/wordpress_allowance`, "manageWeb"),
      }
  }
  get hasServices() {
      return !!(
          this.reseller ||
          this.domain ||
          this.package ||
          this.package_allowance ||
          this.vps ||
          this.managed_vps ||
          this.wordpress_allowance
      )
  }
  get loadedServicesReady() {
      return(
          this.domain !== null &&
          this.vps !== null
      )
  }

  /**
   *
   * @param {string} url
   * @param  {...string} scopes
   */
  async conditionalCollectionLength(url, ...scopes) {
      if(await this.user.checkScopes(...scopes)) {
          return this.collectionLength(url)
      } else {
          return 0
      }
  }
}




"use strict"

/** @file My20i Sidenav */


/**
 * Component for Tier 1 A option
 */
const TierOneOption = Vue.extend({
  name: "tier-one-option",
  template: "#tier-one-option",

  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    img: {
      type: String,
      required: false
    },
    viewbox: {
      type: String,
      default: "0 0 20 20"
    },
    width: {
      type: Number,
      default: 20
    },
    menu:{
      type: String,
      required: false
    }
  }
})


/**
 * Component for Tier 1 B header
 */
const TierOneBHeader = Vue.extend({
  name: "tier-one-b-header",
  template: "#tier-one-b-header",

  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    yadjust: {
      type: Number,
      default: 0
    },
  }
})


/**
 * Component for Tier 1 B collapser
 */
const TierOneBCollapser = Vue.extend({
  name: "tier-one-b-collapser",
  template: "#tier-one-b-collapser",

  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    yadjust: {
      type: Number,
      default: 0
    },
    uuid: {
      type: String,
      required: true
    }
  }
})

/**
 * Component for Tier 1 B item
 */
const TierOneBItem = Vue.extend({
  name: "tier-one-b-item",
  template: "#tier-one-b-item",

  props: {
    label: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    yadjust: {
      type: Number,
      default: 0
    },
  }
})


/**
 * Component for Tier 2 A option
 */
const TierTwoOption = Vue.extend({
  name: "tier-two-option",
  template: "#tier-two-option",

  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    img: {
      type: String,
      required: false
    },
    viewbox: {
      type: String,
      default: "0 0 20 20"
    },
    width: {
      type: Number,
      default: 20
    },
    menu:{
      type: String,
      required: false
    }
  }
})

/**
 * Component for Tier 2 B header
 */
const TierTwoBHeader = Vue.extend({
  name: "tier-two-b-header",
  template: "#tier-two-b-header",

  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    yadjust: {
      type: Number,
      default: 0
    },
  }
})

/**
 * Component for Tier 2 B item
 */
const TierTwoBItem = Vue.extend({
  name: "tier-two-b-item",
  template: "#tier-two-b-item",

  props: {
    label: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    yadjust: {
      type: Number,
      default: 0
    },
  }
})

const UrlServiceTypes = {
    "domain": [
        "/domain/0d1e58663c9049ea",
        "/domain/OID/transfer-domain",
        "/domain/OID/service-overview",
        "/domain/OID/manage-dns",
        "/domain/OID/change-domain-contacts",
        "/domain/OID/whois",
        "/domain/OID/change-nameservers",
        "/domain/OID/manage-domain-privacy",
        "/domain/OID/dnssec-protection",
        "/domain/OID/forwarding",
        "/domain/OID/email/email-accounts",
        "/domain/OID/email/email-forwarders",
        "/domain/OID/email/catchall-forwarders",
        "/domain/OID/email/email-autoresponders",
        "/domain/OID/email/send-only-addresses",
        "/domain/OID/email/receive-only-addresses",
        "/domain/OID/email/junk-mail-filters"
    ],
    "package": [
        "/services/OID/service-overview",
        "/services/OID/cdn/statistics",
        "/services/OID/cdn/traffic-distribution",
        "/services/OID/cdn/caching",
        "/services/OID/cdn/web-optimisation",
        "/services/OID/cdn/security-headers",
        "/services/OID/cdn/cache-report",
        "/services/OID/file-manager",
        "/services/OID/files/ftp-accounts",
        "/services/OID/files/backup-restore",
        "/services/OID/timeline-backups",
        "/services/OID/files/permissions",
        "/services/OID/files/git-version-control",
        "/services/OID/email/email-accounts",
        "/services/OID/email/email-forwarders",
        "/services/OID/email/catchall-forwarders",
        "/services/OID/email/email-autoresponders",
        "/services/OID/email/send-only-addresses",
        "/services/OID/email/receive-only-addresses",
        "/services/OID/email/junk-mail-filters",
        "/services/OID/email/webmail",
        "/services/OID/email/summary",
        "/services/OID/email/imapsync",
        "/services/OID/email/dkim-signatures",
        "/services/OID/email/dmarc-wizard",
        "/services/OID/stats/mail-log",
        "/services/OID/file-manager",
        "/services/OID/software/redirect",
        "/services/OID/files/backup-restore",
        "/services/OID/timeline-backups",
        "/services/OID/security/hotlink-protection",
        "/services/OID/security/ssl-tls",
        "/services/OID/security/password-protection",
        "/services/OID/security/directory-indexing",
        "/services/OID/security/malware-scan",
        "/services/OID/databases/phpmyadmin",
        "/services/OID/databases/mysql-databases",
        "/services/OID/databases/mysql-databaseswp",
        "/services/OID/databases/remote-mysql",
        "/services/OID/software/change-php-version",
        "/services/OID/software/php-configuration",
        "/services/OID/software/manage-app-pool",
        "/services/OID/software/scheduled-tasks",
        "/services/OID/databases/mssql-databases",
        "/services/OID/software/redirect",
        "/services/OID/software/sitemap",
        "/services/OID/software/custom-errors",
        "/services/OID/auto-diagnostics",
        "/services/OID/software/maintenance-mode",
        "/services/OID/domains/manage-domains",
        "/services/OID/domains/manage-subdomains",
        "/services/OID/manage-dns/_NAME_",
        "/services/OID/security/ssh-access",
        "/services/OID/security/ip-blocker",
        "/services/OID/security/hotlink-protection",
        "/services/OID/security/ssl-tls",
        "/services/OID/security/password-protection",
        "/services/OID/security/directory-indexing",
        "/services/OID/security/malware-scan",
        "/services/OID/logs",
        "/services/OID/stats/bandwidth",
        "/services/OID/stats/mail-log",
    ]
};
class ServiceDetect {
    constructor() {
        let urlParts = window.location.pathname.split("/");
        let newURL   = [];
        let OID;
        let nextIsName = false;
        const oidPattern = /^[a-fA-F0-9]{16}$/;
        const idPattern  = /^[0-9]+$/;
        for(const p of urlParts){
            if( nextIsName ) {
                newURL.push("_NAME_");
                nextIsName = false;
            } else if( !OID && oidPattern.test(p) ){
                OID = p;
                newURL.push("OID");
            } else if (!OID && idPattern.test(p)){
                OID = p;
                newURL.push("OID");
            } else {
                if( p == "manage-dns" ){
                    nextIsName = true;
                }
                newURL.push(p);
            }
        }

        this.oid = OID;
        let matchUrl = newURL.join("/");

        for(const serviceType of Object.keys(UrlServiceTypes)){
            if( UrlServiceTypes[serviceType].includes(matchUrl) ){
                this.serviceType = serviceType;
            }
        }

    }

    get domainOid() {
        if( this.serviceType == "domain" ){
            return this.oid;
        } else {
            return null;
        }
    }

    get packageOid() {
        if( this.serviceType == "package" ){
            return this.oid;
        } else {
            return null;
        }
    }
}

const serviceDetector = new ServiceDetect();

/**
 * Vue app
 */
var packageOid = window.location.pathname.split("/")[2];
var isPackage = !window.location.pathname.includes('managed-server') && !window.location.pathname.includes('/domain/');
let select_scroll_limit = 10

let sidenavView = new Vue({
  name: "my20i-sidenav",
  el: "#my20i-sidenav",

  data() {
    const user = User.inst
    return {
      abusiveOrders: null,
      basketClient: AnyBasket.inst,
      /** @type {?SNInvoiceCollection} */
      unpaidOrders: null,
      /** @type {?RenewalRunConfigReadOnly} */
      renewalConfig: null,
      /** @type {?SBProvisionQueue[]} */
      provisionQueueEntries: null,
      serviceDetector: serviceDetector,
      /** @type {HTMLElement} */
      el: null,
      tier1MobileOpen: false,
      tier2MobileOpen: false,
      /** @type {?string} */
      tier1Menu: null,
      /** @type {?string} */
      tier2Menu: null,
      userContactInfo: UserContactInfo.inst,
      user: user,
      /** @type boolean */
      get agencyHubEnabled() {
        return this.user.hasAgencyHub;
      },
      /** @type {?{ incidents: any[], maintenance: any[] }} */
      statusPageData: null,
      /**
       * @type {null|SupportArticles}
       */
      supportArticles: null,
      help: {
        articleInView: null,
        /**
         * @type {supportArticle[]}
         */
        supportArticleData: [],
        topSupportSearch: null,
      },
      ticketCount: 0,
      /** @type {?ServiceCounts2} */
      serviceCounts: null,
      serviceCountsReady: false,
      /** @type {?ServiceLimits2} */
      serviceLimits: null,
      get oid() {
          return this.serviceDetector.oid
      },
      get limits() {
        return this.serviceLimits?.limits
      },
      get isValidOid() {
        const regex = /^0x[0-9A-Fa-f]+$|^[0-9A-Fa-f]+$/;
        return !window.location.pathname.includes('messages') && !window.location.pathname.includes('stack-users') && regex.test(this.serviceDetector.oid);
      },
      get isPackage() {
         return this.serviceDetector.packageOid;
      },
      platform: null,
      profileId: null,
      /** @type {?domainIn[]} */
      domains: null,
      /** @type {?string[]} */
      modalNames: null,
      /** @type {?string[]} */
      dnsServiceNames: null,
      /** @type {?(string) => string} */
      expandLink: null,
      /**
       * @type {?{current: null,  installed: null,isMultisite: boolean, isLatest: null, latest: null, wizardRequired: null}}
       */
      wordpressIsInstalled: {
        isLatest: null,
        current: null,
        latest: null,
        isMultisite: false,
        installed: null,
        wizardRequired: null,
      },
      recentlyViewed: null,
      favouritePackages: null,
      recentOrFavourite: "recent",
      packageFetch: {
        method: "get",
        url: `/a/package`,
        data(params) {
            return {
                fields: ["name", "id"],
                selector: {
                    name: params.term ? {
                        '$regex': "^" + params.term.replace(
                            /.*\//,
                            ""
                        ).replace(
                            /([.?+*\(\)\[\]\{\}-])/g,
                            (s, m1) => `[${m1}]`
                        ).replace(/\\/, "\\\\"),
                    } : undefined
                },
                sort: ["names"],
                limit: (params && params.term && params.term != '') ? 1000 : select_scroll_limit,
                skip:
                    select_scroll_limit *
                        ((params.page || 1) - 1),
            }
        },
        processResults(results) {
            return {
                results: results.map(p => ({
                    text: p.name,
                    id: p.id,
                })),
                pagination: {
                    more: results.length == select_scroll_limit,
                },
            }
        },
      },
      selectedManagePackage: null,

      get servicesOperational() {
        let operational = true

        if (!this.statusPageData) return false

        const hasIncident = this.statusPageData.incidents.some((incident) => incident.status !== 'Fixed')
        const hasMaintenance = this.statusPageData.maintenance.some((maintenace) => maintenace.status !== 'Complete')

        if (hasIncident || hasMaintenance) {
            operational = false
        }

        this.servicesOperationalFetched = true;
        return operational
      },
      servicesOperationalFetched: false,

      get upcomingMaintenance() {
        return this.statusPageData?.maintenance.some((maintenace) => maintenace.status !== 'Complete')
      },

      get topSupportArticles() {
        if(!this.supportArticles) return null
        /**
         * @type {supportArticle[]}
         */
        if(this.help.topSupportSearch) {
            return this.supportArticles.findAndReturn(this.help.topSupportSearch)
        } else if($(".onpageHelpInitialSearch").length && this.help.topSupportSearch === null) {
            var dsv = $(".onpageHelpInitialSearch")[0].value;
            if( dsv.match(/\[/) ){
                let defaultTopFive = JSON.parse( dsv );
                return this.supportArticles.findAndReturnByIds(defaultTopFive)
            } else {
                this.help.topSupportSearch = dsv;
            }
        } else {
            const articles = this.supportArticles.articles.slice()
            return articles.sort((a, b) => b.impressions - a.impressions).slice(0, 5)
        }
      },

      get showSection() {
          let limits = this.serviceLimits?.limits || {};
          return{
              domains: limits?.dns ||
                  limits?.domainContacts ||
                  limits?.nameservers ||
                  limits?.pushTransfer ||
                  limits?.domainPrivacy ||
                  limits?.domains ||
                  limits?.subdomains ||
                  limits?.whois,
              email: limits?.mailJunkFilters ||
                  limits?.mailCatchAllForwarders ||
                  limits?.mailAutoresponders ||
                  limits?.mailForwarders ||
                  limits?.mailboxes ||
                  limits?.webmail,
              files: limits?.fileManager ||
                  limits?.ftp ||
                  limits?.backups ||
                  limits?.webBuilder,
              logstat: limits?.awstats ||
                  limits?.webalizer ||
                  limits?.accessErrorLogs ||
                  limits?.timelineBackups,
              oneclick: (limits?.apps &&
                  Object.keys(limits?.apps).length && (this.platform === 'virtual' || this.platform === 'linux' || this.platform === 'free')) || limits?.allFutureOneClick && (this.platform === 'virtual' || this.platform === 'linux' || this.platform === 'free'),
              security: limits?.blockVisitors ||
                  limits?.passwordProtectedDirectories ||
                  limits?.directoryIndexing ||
                  limits?.freeSsl ||
                  limits?.ssh ||
                  limits?.hotlinkProtection,
              webtools: limits?.switchPhpVersion ||
                  limits?.mysqlDatabases ||
                  limits?.scheduledTasks ||
                  limits?.phpMyAdmin ||
                  limits?.webRedirect,
              wordpress: (
                  (this.platform === 'wordpress' || (this.platform === 'virtual' && (this.profileId === 2||this.profileId === 4) ) ) &&
                    ( limits?.wpAdmin ||
                      limits?.manageWpPlugins ||
                      limits?.manageWpThemes ||
                      limits?.manageWpUsers ||
                      limits?.manageWpSiteSettings ||
                      limits?.manageWpStaging ||
                      limits?.manageWpChecksumReport
                    )
                  ),
              woocommerce: (this.platform === 'virtual' && this.profileId === 4),
              laravel: (this.platform === 'virtual' && this.profileId === 5)
          }
      },

    }
  },

  computed: {
  },

  watch: {
    "serviceCounts.loadedServicesReady": function(v) {
        if( v ){
            this.$nextTick(() => {
                // this.initSort();
                this.serviceCountsReady = true
            } );
        }
    },
    selectedManagePackage(v) {
      if (v) {
          this.accessPackage()
      }
  },
  },

  methods: {
    async loadFailedOrders() {
      try {
        /** @type {*[]} */
        const data = await $.ajax({
            method: "get",
            url: `/s/provisionQueue`,
            data: {
                fields: [
                    "contract.expiryDate",
                    "contract.id",
                    "contract.preferredPaymentId",
                    "contract.preferredPaymentType",
                    "contract.preferredRenewalAction",
                    "contract.preferredRenewalMonths",
                    "contract.productCode",
                    "contract.serviceId",
                    "contract.serviceName",
                    "contract.serviceType",
                    "contract.upstreamRepeatPaymentRef",
                    "contract.linkUser",
                    "id",
                    "action",
                    "actionContent",
                    "condition",
                    "createdAt",
                    "state",
                    "updatedAt",
                ],
                selector: {
                    $or: [
                        {
                            state: {
                                $type: "null",
                            }
                        },
                        {
                            state: "failed",
                        },
                    ],
                },
            },
      })
        // Note that these are in original order to encourage
        // resending in the same order (not anachronous)
        this.provisionQueueEntries = data.map(
            d => new SBProvisionQueue(d, this.renewalConfig)
        )
      } catch(e) {
        console.log(e)
        ShowNotification.fail(
            "There was a problem fetching your provision queue entries. Please contact support."
        )
      }
    },
    /**
     * Makes the side nav occupy the space between the top nav and the bottom of
     * the viewport.
     */
    my20iSideNavScroll() {
      var scrollPosition = window.scrollY || window.pageYOffset
      if(scrollPosition < 82) {
        this.el.style.maxHeight = `calc(100vh + ${scrollPosition - 81}px)`
      } else {
        this.el.style.maxHeight = "100vh"
      }
    },

    /**
     * Toggle tier 1 menu on mobile.
     */
    toggleTier1Menu() {
      this.tier1MobileOpen = !this.tier1MobileOpen;
    },

    /**
     * Opens a tier 1 menu, and closes any open tier 2 menus.
     * @param {string} menu
     */
    openTier1Menu(menu) {
      this.tier2Menu = null
      if(menu === this.tier1Menu) {
        this.tier1Menu = null
      } else {
        this.tier1Menu = menu
      }
    },

     /**
     * Toggle tier 2 menu on mobile.
     */
     toggleTier2Menu() {
      this.tier2MobileOpen = !this.tier2MobileOpen;
    },

    /**
     * Opens a tier 2 menu, and closes any open tier 2 menus.
     * @param {string} menu
     */
    openTier2Menu(menu) {
      this.tier1Menu = null
      if(menu === this.tier2Menu) {
        this.tier2Menu = null
      } else {
        this.tier2Menu = menu
      }
    },

    /**
     * If the user clicks outside the component, close all the menus.
     * @param {*} event
     */
    clickListener(event) {
      const clickedElement = event.target;
      if (!clickedElement.closest('#my20i-sidenav')) {
        this.tier1Menu = null;
        this.tier2Menu = null;
      }
    },

    /** Toggle AI chat */
    toggleChat() {
      document.getElementById('ai-chat-button').click();
      $('.nav-support__content').css('pointer-events', 'none');
      setTimeout(function() {
          $('.nav-support__content').css('pointer-events', 'auto');
      }, 500);
    },

    storeSearch() {
      clearTimeout(this.debounce)
      this.debounce = null
      if(this.help.topSupportSearch && this.help.topSupportSearch !== "") {
        this.debounce = setTimeout(() => {
          if(this.supportArticles) {
            this.supportArticles.searchStoreQuery(this.help.topSupportSearch)
          }
        }, 2000)
      }
    },

    /**
     *
     * @param {string} type
     */
    async gotoWebStats(type) {
      try {
          /** @type {webIn} */
          const web = await $.ajax({
              dataType: "json",
              method: "get",
              url: `/a/package/${this.serviceDetector.packageOid}/web`,
              async: false // Popup blocker?
          })
          if(!web.info) {
              throw new Error(
                  "Platform error getting web stats URL"
              )
          }
          window.open(web.info.statsUrls[type]);
      } catch(e) {
          ShowNotification.fail(
              translation.get('service_overview_shared_notification_fail_retrieve_web_stats')
          )
      }
    },

    /**
     *
     * @param {(string) => string} f
     * @param {string[]} names
     */
    selectName(f, names) {
      if(names.length == 1) {
          this.modalNames = null
          location.href = f(names[0])
      } else {
          this.expandLink = f
          this.modalNames = names.sort()
          $("#domain-modal-sidenav").modal('show').css({ background: "rgba(0, 0, 0, 0.5)" });
          $('.modal-backdrop').remove()
      }
    },

    viewDns() {
      if(!this.dnsServiceNames) {
          throw new Error("No DNS services loaded yet")
      }
      this.selectName(
          domain => `/services/${this.serviceDetector.packageOid}/manage-dns/${domain}`,
          this.dnsServiceNames
      )
    },

    /**
     * @param {string} url
     */
    domainFunctionClicked(url) {
      const domains = this.domains
      if(!domains) {
          throw new Error("No domains loaded")
      }
      this.selectName(
          name => {
              const domain = domains.find(
                  domain => domain.name == name
              )
              if(!domain) {
                  throw new Error("Domain not found?")
              }
              return `/domain/${domain.oid}/${url}`
          },
          domains.map(domain => domain.name)
      )
    },

    async getWordpressVersion() {
      if(
          this.platform == "wordpress" ||
          this.profileId == 2 ||
          this.profileId == 4
      ) {
          this.wordpressIsInstalled = {
              isLatest: null,
              current: null,
              latest: null,
              installed: null,
              isMultisite: false,
              wizardRequired: null,
          }
          try {
              this.wordpressIsInstalled = await $.ajax(`/x/package/${this.serviceDetector.packageOid}/web/wordpressVersion`)
          } catch(e) {
              this.wordpressIsInstalled = null
          }
      }
    },

    accessPackage() {
      $.ajax({
          method: "get",
          url: `/o/package`,
          data: {
              fields: ["id"],
              selector: {
                  id: this.selectedManagePackage,
              }
          },
          async: false,
      }).done(result => {
          location.href =
              `/services/${result[0].oid}/service-overview`
      })
    },

    loadRecentAndFavourites() {
      $.ajax(`/a/recently_viewed`)
        .done(r => {
            this.recentlyViewed = r
        })

      $.ajax(`/a/favourites`)
        .done(r => {
            this.favouritePackages = r
        })
    },

    loadSupportArticles() {
      this.supportArticles = typeof SupportArticles != "undefined" ? new SupportArticles(this.user.hasReseller !== null ? this.user.hasReseller : false) : null
    },

    async loadStackStatusIncidents() {
      this.statusPageData = await $.ajax("https://www.stackstatus.com/api/incidents")
    },

    loadBoth() {
      this.loadSupportArticles();
      this.loadStackStatusIncidents();
    }

  },

  components: {
    TierOneOption,
    TierOneBHeader,
    TierOneBCollapser,
    TierOneBItem,
    TierTwoOption,
    TierTwoBHeader,
    TierTwoBItem,
    VueSelect
  },

  async mounted() {
    this.el = document.getElementById('my20i-sidenav')
    window.addEventListener('scroll', this.my20iSideNavScroll, {passive: true})

    const aaa = document.getElementById("sideNavMainMenuButton");
    if (this.toggleTier1Menu) {
      aaa.addEventListener('click', this.toggleTier1Menu)
    }
    window.addEventListener('click', this.clickListener)

    // this.statusPageData = await $.ajax("https://www.stackstatus.com/api/incidents")

    this.ticketCount = await NPSUtil.collectionLength(
      `/a/ticket`,
      {
          hideAsFlagged: {
              awaitingReply: +false,
              isOpen: +false,
          }
      }
    )


    let user = User.inst;
    await user.preloadSingle("identityInfo");
    if( user.scopesInclude('manageHostShop') ) {
        try {
          this.abusiveOrders = new SNInvoiceCollection(
              (await SNInvoiceCollection.fetchAbuse()).sort(
                  (a, b) => +!!a.unpaid - +!!b.unpaid
              )
          )

          this.unpaidOrders = new SNInvoiceCollection(
              (await SNInvoiceCollection.fetchNotPaid()).sort(
                  (a, b) => +!!a.unpaid - +!!b.unpaid
              )
          )
        } catch(e) {
            console.log(e)
            ShowNotification.fail(
                "There was a problem fetching your invoices. Please contact support."
            )
        }
    }


    if (this.serviceDetector.packageOid) {
      let p = await $.ajax({
        method: "get",
        url: `/a/package/${this.serviceDetector.packageOid}/web/info`,
      }).done(
        async results => {
          let r = results;
          if (r) {
            this.platform = r.platform;
            this.profileId = r.profileId;
          }
        }
      )
    }

    this.serviceLimits = new ServiceLimits2("package", packageOid)

    this.serviceCounts = await new ServiceCounts2(this.user)

    if (this.serviceDetector.packageOid) {
      $.ajax(`/a/package/${this.serviceDetector.packageOid}/domain`).done(
        /** @param {domainIn[]} domains */
        domains => this.domains = domains
      );

      $.ajax(`/a/package/${this.serviceDetector.packageOid}/dns`).done(
        /** @param {GET.Services.package.id.dns.output} dns */
        dns => this.dnsServiceNames = Object.keys(dns)
      )
      this.getWordpressVersion();
    }

    if( user.scopesInclude('manageHostShop') ){
        await this.loadFailedOrders();
    }
  }
})
